import React, { useEffect, useState } from 'react';
import api from '../../services/api';

const FIELDS = [
  { key: 'etablissement_nom',       label: 'Nom de l\'établissement',     type: 'text' },
  { key: 'etablissement_adresse',   label: 'Adresse complète',            type: 'text' },
  { key: 'etablissement_telephone', label: 'Téléphone',                   type: 'tel' },
  { key: 'proviseur_civilite',      label: 'Civilité du proviseur',       type: 'select', options: ['M.', 'Mme'] },
  { key: 'proviseur_nom',           label: 'Nom du proviseur',            type: 'text' },
  { key: 'principal_email',         label: 'Email du proviseur (DocuSeal)', type: 'email' },
  { key: 'principal_name',          label: 'Nom complet du proviseur (DocuSeal)', type: 'text' },
  { key: 'docuseal_admin_email',    label: 'Email du compte admin DocuSeal', type: 'email' },
];

export default function SettingsTab() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/admin/settings')
      .then(res => setForm(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccess(false);
    setError('');
    try {
      await api.put('/admin/settings', form);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const inputClass = 'w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500';

  if (loading) return <div className="text-gray-500 text-sm">Chargement...</div>;

  return (
    <form onSubmit={handleSubmit} className="max-w-xl space-y-5">
      <p className="text-sm text-gray-500">
        Ces informations apparaissent sur les conventions PDF générées.
      </p>

      {FIELDS.map(({ key, label, type, options }) => (
        <div key={key}>
          <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
          {type === 'select' ? (
            <select
              value={form[key] || ''}
              onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))}
              className={inputClass}
            >
              {options.map(o => <option key={o} value={o}>{o}</option>)}
            </select>
          ) : (
            <input
              type={type}
              value={form[key] || ''}
              onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))}
              className={inputClass}
            />
          )}
        </div>
      ))}

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
          {error}
        </div>
      )}
      {success && (
        <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">
          Paramètres sauvegardés.
        </div>
      )}

      <button
        type="submit"
        disabled={saving}
        className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white text-sm font-medium px-5 py-2.5 rounded-lg transition-colors"
      >
        {saving ? 'Sauvegarde...' : 'Sauvegarder'}
      </button>
    </form>
  );
}
